import { createStyles, makeStyles } from "@material-ui/core";
import { DisplayField, Label, LayoutContainer, Link, RelodeTheme, Text, } from "@relode/core";
import * as React from "react";

import {
    CandidateHighlights as CandidateOverviewType,
    CandidateJobDetails,
} from "../../types";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                flexDirection: "column",
                marginTop: theme.spacing(1),
                rowGap: "24px",
            },
            label: {
                color: theme.relode.colors.label.main,
                marginTop: 4,
            },
        }),
    { name: "CandidateJobDetailsMobile" }
);

interface CandidateJobDetailsMobileProps {
    job?: CandidateJobDetails;
    currentLeadId?: number;
    highlights?: CandidateOverviewType;
}

export const CandidateJobDetailsMobile = (
    props: CandidateJobDetailsMobileProps
) => {
    const classes = useStyles({});
    const { job, currentLeadId, highlights } = props;

    if (!job) return null;

    return (
        <LayoutContainer>
            <Text variant="h2" gutterBottom>overview</Text>
            <div className={classes.root}>
                <Label label="job title">
                    <>
                        <Text variant="body1">
                            {currentLeadId ? (
                                <Link
                                    to={{
                                        pathname: `/jobs/${job?.jobId}`,
                                        state: {
                                            backUrl: `/candidates/${job?.jobId}/${currentLeadId}`,
                                        },
                                    }}
                                >
                                    {job?.jobName}
                                </Link>
                            ) : (
                                job?.jobName
                            )}
                        </Text>
                        <Text className={classes.label} variant="caption">
                            {job?.location.locationName}
                        </Text>
                    </>
                </Label>

                {!!highlights && highlights.careerHighlightNote ? (
                    <DisplayField
                        label="career highlights"
                        showHeader={false}
                        value={highlights?.careerHighlightNote}
                        preserveTextFormat
                        data-cy="careerHighlightNote"
                    />
                ) : null}
            </div>
        </LayoutContainer>
    );
};
